export default __webpack_public_path__ + "230afeb209740a1c182dcfa5bd24c3d9.png";